var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitleBack3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 864.55 342.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#455465;}.cls-2{fill:#4588aa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "510.44 204.5 471.47 137.01 510.44 69.52 588.37 69.52 627.33 137.01 588.37 204.5 510.44 204.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.92,72l37.52,65-37.52,65h-75l-37.52-65,37.52-65h75m2.89-5H509l-40.4,70L509,207h80.82l40.41-70L589.81,67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "627.36 272.48 588.39 204.99 627.36 137.5 705.28 137.5 744.25 204.99 705.28 272.48 627.36 272.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M703.84,140l37.52,65-37.52,65h-75l-37.52-65,37.52-65h75m2.89-5H625.91L585.5,205l40.41,70h80.82l40.4-70-40.4-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "392.85 272.56 353.89 205.07 392.85 137.58 470.78 137.58 509.74 205.07 470.78 272.56 392.85 272.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.34,140.08l37.52,65-37.52,65h-75l-37.52-65,37.52-65h75m2.88-5H391.41l-40.41,70,40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "509.77 339.54 470.81 272.05 509.77 204.56 587.7 204.56 626.66 272.05 587.7 339.54 509.77 339.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.25,207.06l37.53,65-37.53,65h-75l-37.52-65,37.52-65h75m2.89-5H508.33l-40.41,70,40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "392.85 137.48 353.89 69.99 392.85 2.5 470.78 2.5 509.74 69.99 470.78 137.48 392.85 137.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M469.34,5l37.52,65-37.52,65h-75L356.77,70,394.29,5h75m2.88-5H391.41L351,70l40.41,70h80.81l40.41-70L472.22,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "743.77 340.48 704.81 272.99 743.77 205.5 821.7 205.5 860.66 272.99 821.7 340.48 743.77 340.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M820.26,208l37.52,65-37.52,65h-75l-37.52-65,37.52-65h75m2.88-5H742.33l-40.41,70,40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "627.85 137.56 588.89 70.07 627.85 2.58 705.78 2.58 744.74 70.07 705.78 137.56 627.85 137.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M704.34,5.08l37.52,65-37.52,65H629.29l-37.52-65,37.52-65h75.05m2.88-5H626.41L586,70.07l40.41,70h80.81l40.41-70L707.22.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "744.77 205.53 705.81 138.05 744.77 70.56 822.7 70.56 861.66 138.05 822.7 205.53 744.77 205.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M821.26,73.06l37.52,65-37.52,65h-75l-37.52-65,37.52-65h75m2.88-5H743.33l-40.41,70,40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.44 204.5 236.47 137.01 275.44 69.52 353.37 69.52 392.33 137.01 353.37 204.5 275.44 204.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.92,72l37.52,65-37.52,65h-75l-37.52-65,37.52-65h75m2.89-5H274l-40.4,70L274,207h80.82l40.41-70L354.81,67Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "158.85 272.56 119.89 205.07 158.85 137.58 236.78 137.58 275.74 205.07 236.78 272.56 158.85 272.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.34,140.08l37.52,65-37.52,65H160.29l-37.52-65,37.52-65h75.05m2.88-5H157.41l-40.41,70,40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "275.77 339.54 236.81 272.05 275.77 204.56 353.7 204.56 392.66 272.05 353.7 339.54 275.77 339.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M352.25,207.06l37.53,65-37.53,65h-75l-37.52-65,37.52-65h75m2.89-5H274.33l-40.41,70,40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "158.85 137.48 119.89 69.99 158.85 2.5 236.78 2.5 275.74 69.99 236.78 137.48 158.85 137.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M235.34,5l37.52,65-37.52,65H160.29L122.77,70,160.29,5h75.05m2.88-5H157.41L117,70l40.41,70h80.81l40.41-70L238.22,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.85 339.56 2.89 272.07 41.85 204.58 119.78 204.58 158.74 272.07 119.78 339.56 41.85 339.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.34,207.08l37.52,65-37.52,65H43.29l-37.52-65,37.52-65h75.05m2.88-5H40.41L0,272.07l40.41,70h80.81l40.41-70-40.41-70Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.85 204.48 2.89 136.99 41.85 69.5 119.78 69.5 158.74 136.99 119.78 204.48 41.85 204.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.34,72l37.52,65-37.52,65H43.29L5.77,137,43.29,72h75.05m2.88-5H40.41L0,137l40.41,70h80.81l40.41-70L121.22,67Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleBack3);
export default __webpack_public_path__ + "static/media/title-back-3.b4c418919e254928da189724af8d89a5.svg";
export { ForwardRef as ReactComponent };